import { render } from "./ProductionSchedule.vue?vue&type=template&id=fa0c7938"
import script from "./ProductionSchedule.vue?vue&type=script&lang=js"
export * from "./ProductionSchedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__